export default [
  {
    itemType: 'group',
    colCount: 2,
    items: [
      {
        colSpan: 2,
        dataField: 'nome',
        label: { text: 'Nome' },
        validationRules: [{
          type: 'required',
          message: 'Nome é obrigatório'
        }]
      },
      {
        template: 'fieldGrupo'
      },
      {
        dataField: 'email',
        label: { text: 'Email' },
        editorOptions: {
          mode: 'email'
        },
        validationRules: [{
          type: 'required',
          message: 'Email é obrigatório'
        }, {
          type: 'email',
          message: 'Email precisa ser válido'
        }]
      },
      {
        dataField: 'senha',
        label: { text: 'Senha' },
        editorOptions: {
          mode: 'password'
        }
      },
      {
        dataField: 'confirma_senha',
        label: { text: 'Confirma Senha' },
        editorOptions: {
          mode: 'password'
        }
      }
    ]
  }
]
